import { useEffect, useState } from 'react';
import MedicineDetailsAutocomplete from './medicineDetailsAutocomplete';
import { useTranslation } from 'react-i18next';
import MedicineSelectedBox from './medicineSelectedBox';

const MedicineDetailsContainer = ({ value, handleChange, mainMedicine, handleChangeMainForm, disabled }) => {
    const { t } = useTranslation();
    const [brandMedicine, setBrandMedicine] = useState(value?.amp || null);
    const [packMedicine, setPackMedicine] = useState(value?.ampp || null);

    useEffect(() => {
        if (value) {
            setBrandMedicine(value.amp);
            setPackMedicine(value.ampp);
        } else {
            setBrandMedicine(null);
            setPackMedicine(null);
        }
    }, [mainMedicine, value]);

    const handleClearBrand = () => {
        setBrandMedicine(null);
        setPackMedicine(null);

        handleChangeMainForm((prev) => ({
            ...prev,
            amp: null,
            ampp: null,
        }));
    };

    const handleClearPack = () => {
        setPackMedicine(null);

        handleChangeMainForm((prev) => ({
            ...prev,
            ampp: null,
        }));
    };

    const handleChangeBrandMedicine = (newValue) => {
        setBrandMedicine(newValue);

        handleChangeMainForm((prev) => ({
            ...prev,
            amp: { ...prev.amp, ...newValue },
        }));
    };

    const handleChangePackMedicine = (newValue) => {
        setPackMedicine(newValue);

        handleChangeMainForm((prev) => ({
            ...prev,
            ampp: { ...prev.ampp, ...newValue },
        }));
    };

    const handleSetupRoute = (route, form, unitDoseUnit) => {
        const formVal = form ? { code: form?.code, value: form?.display } : {};
        const routeVal = route ? { code: route?.code, value: route?.display } : {};
        const unitDoseUnitVal = unitDoseUnit ? { code: unitDoseUnit?.code, value: unitDoseUnit?.display } : {};

        handleChangeMainForm((prev) => ({
            ...prev,
            form: { ...prev.form, ...formVal },
            route: { ...prev.route, ...routeVal },
            unitDoseUnit: { ...prev.unitDoseUnit, ...unitDoseUnitVal },
        }));
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 5 }}>
            {mainMedicine &&
                (!brandMedicine ? (
                    // set fixed size due to dynamic height of the MedicineDetailsAutocomplete component
                    <div style={{ minHeight: 112 }}>
                        <MedicineDetailsAutocomplete
                            mainCode={mainMedicine?.code}
                            placeholder={t('Select brand or manufacturer (optional)')}
                            value={brandMedicine}
                            handleChangeValue={handleChangeBrandMedicine}
                            handleChangeRoute={handleSetupRoute}
                            disabled={disabled}
                        />
                    </div>
                ) : (
                    <MedicineSelectedBox medicine={brandMedicine} onChange={handleClearBrand} type="AMP" disabled={disabled} />
                ))}
            {brandMedicine && (
                // set fixed size due to dynamic height of the MedicineDetailsAutocomplete component
                <div style={{ minHeight: 112 }}>
                    <MedicineDetailsAutocomplete
                        mainCode={brandMedicine?.code}
                        placeholder={t('More specific options (e.g., packaging type) are available for this product. (optional)')}
                        value={packMedicine}
                        handleChangeValue={handleChangePackMedicine}
                        disabled={disabled}
                    />
                    {packMedicine && (
                        <MedicineSelectedBox medicine={packMedicine} onChange={handleClearPack} type="AMPP" disabled={disabled} />
                    )}
                </div>
            )}
        </div>
    );
};

export default MedicineDetailsContainer;
